// extracted by mini-css-extract-plugin
export default {"cart":"CartPage_cart__owI5I","cart-name":"CartPage_cart-name__k2mzB","layout":"CartPage_layout__DNHL5"};